import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import event from '../views/event/event.vue'
import isiEvent from '../views/event/isiEvent.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import produkHukum from '../views/profil/produkHukum.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import tentang from '../views/profil/tentang.vue'
import tugasPokok from '../views/profil/tugasPokok.vue'
import tujuanSasaran from '../views/profil/tujuanSasaran.vue'
import ipw_I from '../views/unitKerja/ipw_I.vue'
import ipw_II from '../views/unitKerja/ipw_II.vue'
import ipw_III from '../views/unitKerja/ipw_III.vue'
import ipw_IV from '../views/unitKerja/ipw_IV.vue'
import sekretaris from '../views/unitKerja/sekretaris.vue'
import reviuDAK from '../views/reviu/reviuDAK.vue'
import reviuRKA from '../views/reviu/reviuRKA.vue'
import reviuPAPBJ from '../views/reviu/reviuPAPBJ.vue'
import lhkpn from '../views/informasiPengawasan/lhkpn.vue'
import pmprb from '../views/informasiPengawasan/pmprb.vue'
import radpk from '../views/informasiPengawasan/radpk.vue'
import saberPungli from '../views/informasiPengawasan/saberPungli.vue'
import spip from '../views/informasiPengawasan/spip.vue'
import tp4d from '../views/informasiPengawasan/tp4d.vue'
import upg from '../views/informasiPengawasan/upg.vue'
import wbs from '../views/informasiPengawasan/wbs.vue'
import zonaIntegritas from '../views/informasiPengawasan/zonaIntegritas.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/event',
    name: 'event',
    component: event
  },
  {
    path: '/isiEvent',
    name: 'isiEvent',
    component: isiEvent
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/produkHukum',
    name: 'produkHukum',
    component: produkHukum
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/tentang',
    name: 'tentang',
    component: tentang
  },
  {
    path: '/tugasPokok',
    name: 'tugasPokok',
    component: tugasPokok
  },
  {
    path: '/tujuanSasaran',
    name: 'tujuanSasaran',
    component: tujuanSasaran
  },
  {
    path: '/ipw_I',
    name: 'ipw_I',
    component: ipw_I
  },
  {
    path: '/ipw_II',
    name: 'ipw_II',
    component: ipw_II
  },
  {
    path: '/ipw_III',
    name: 'ipw_III',
    component: ipw_III
  },
  {
    path: '/ipw_IV',
    name: 'ipw_IV',
    component: ipw_IV
  },
  {
    path: '/sekretaris',
    name: 'sekretaris',
    component: sekretaris
  },
  {
    path: '/reviuDAK',
    name: 'reviuDAK',
    component: reviuDAK
  },
  {
    path: '/reviuRKA',
    name: 'reviuRKA',
    component: reviuRKA
  },
  {
    path: '/reviuPAPBJ',
    name: 'reviuPAPBJ',
    component: reviuPAPBJ
  },
  {
    path: '/lhkpn',
    name: 'lhkpn',
    component: lhkpn
  },
  {
    path: '/pmprb',
    name: 'pmprb',
    component: pmprb
  },
  {
    path: '/radpk',
    name: 'radpk',
    component: radpk
  },
  {
    path: '/saberPungli',
    name: 'saberPungli',
    component: saberPungli
  },
  {
    path: '/spip',
    name: 'spip',
    component: spip
  },
  {
    path: '/tp4d',
    name: 'tp4d',
    component: tp4d
  },
  {
    path: '/upg',
    name: 'upg',
    component: upg
  },
  {
    path: '/wbs',
    name: 'wbs',
    component: wbs
  },
  {
    path: '/zonaIntegritas',
    name: 'zonaIntegritas',
    component: zonaIntegritas
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
